export default __webpack_public_path__ + "static/media/aiocr-bluepurple-256.58ad2ef5.png";